// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__oE7+8","name":"styles_name__kHcbG","arrow_icon":"styles_arrow_icon__gBoFx"};